function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M137 98c11.93 0 21.602 9.671 21.602 21.602v11.268"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137 106c7.456 0 13.5 6.044 13.5 13.5v11.496"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  d: "M5 .5A4.5 4.5 0 00.5 5v111a4.5 4.5 0 004.5 4.5h128a4.5 4.5 0 004.5-4.5V5A4.5 4.5 0 00133 .5H5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M131.435 121v9.542H6.587V121"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.542 13.5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001M106.542 13.5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001M74.542 13.5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 65h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001M42.542 13.5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 65h20.001m-20.001 5h20.001m-20.001 5h20.001m-20.001 5h20.001",
  stroke: "#4A4A4A",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.367 46.367L63.5 56.5M64 46L54 56l10-10zM74.367 46.367L84.5 56.5M85 46L75 56l10-10zM93.382 73.83c-6.676-.927-15.758-2.348-23.797-2.348-9.075 0-17.321 1.186-24.585 2.349",
  stroke: "#4A4A4A"
}));

function SvgHvacBroken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 132,
    viewBox: "0 0 160 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvacBroken);
export default __webpack_public_path__ + "static/media/HvacBroken.a30b605c.svg";
export { ForwardRef as ReactComponent };